import { fontBody, fontTitle } from 'Styles/fonts';

/**
 * Mappings that match a Card (i.e. Content Card, Image Card, or Text Card)
 * with a shared font size/styles. Keys relate to responsive style sizes of cards.
 */
const FONT_STYLES = {
  mini: {
    title: `${fontTitle(16)}`,
    text: `${fontBody(14)}`,
    padding: '8px'
  },
  regular: {
    title: `${fontTitle(20)}`,
    text: `${fontBody(14)}`,
    padding: '12px'
  },
  mega: {
    title: `${fontTitle(24)}`,
    text: `${fontBody(16)}`,
    padding: '20px'
  }
};

/**
 * Gets a target style size and type combination from the FONT_STYLES object
 *
 * @param {(mini|regular|mega)} size - one of three style size options
 * @param {(title|text)} value - the target style
 * @returns {String} - styles to be interpolated by styled components
 */
export const getStyle = (size, value) => FONT_STYLES[size]?.[value];

export default {};
